// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase"



const firebaseConfig = {
    apiKey: "AIzaSyBMvDK5raxvq6xh7AJv3jBgFmP3xR1GwUI",
    authDomain: "clone-f0c77.firebaseapp.com",
    projectId: "clone-f0c77",
    storageBucket: "clone-f0c77.appspot.com",
    messagingSenderId: "1064863341467",
    appId: "1:1064863341467:web:6d537488c182d22e7b5f3e",
    measurementId: "G-VBB88WS3FE"
  };


const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };